import React, {createContext} from 'react';
export const OrbitsContext = createContext()

export function OrbitsProvider(props) {
    return  <OrbitsContext.Provider {...props} />;
}



